import { render, staticRenderFns } from "./boat-card-skeleton.vue?vue&type=template&id=c0fb5b9c&scoped=true"
import script from "./boat-card-skeleton.vue?vue&type=script&lang=js"
export * from "./boat-card-skeleton.vue?vue&type=script&lang=js"
import style0 from "./boat-card-skeleton.vue?vue&type=style&index=0&id=c0fb5b9c&prod&lang=scss"
import style1 from "./boat-card-skeleton.vue?vue&type=style&index=1&id=c0fb5b9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fb5b9c",
  null
  
)

export default component.exports